'use es6';

import http from 'hub-http/clients/apiClient';
import formatEmailSubscriptions from 'reference-resolvers/formatters/formatEmailSubscriptions';
import formatEmailSubscriptionGroups from 'reference-resolvers/formatters/formatEmailSubscriptionGroups';
const BASE_URL = '/subscriptions/v1/definitions';
const GROUPS_BASE_URL = 'subscriptions/v1/preferences-group/all/with-permissions';
export const createGetEmailSubscriptions = ({
  httpClient
}) => () => httpClient.get(BASE_URL, {
  query: {
    includeInternal: true
  }
}).then(formatEmailSubscriptions);
export const createGetEmailSubscriptionGroups = ({
  httpClient
}) => () => httpClient.get(GROUPS_BASE_URL).then(formatEmailSubscriptionGroups);
export const getEmailSubscriptions = createGetEmailSubscriptions({
  httpClient: http
});
export const getEmailSubscriptionGroups = createGetEmailSubscriptionGroups({
  httpClient: http
});